define(['angular'], function(angular) {


    /**
     * @class filesService
     */
    function FilesService(filesProvider, $rootScope) {
        var self = this;

        // Files root folder
        self.ROOT_PATH = './files/';

        self.filterFiles = function filterFiles(category) {
            return self.FILES.filter(function(file) {
                return file.category === category;
            });
        };

        self.FILES = [
            // produits
            { name: 'Fiche Boulangerie', url: 'BIMEDIA_FICHE_METIERS_2022_BOULANGERIE.pdf', category_name: 'produits' },
            { name: 'Fiche Restauration', url: 'BIMEDIA_FICHE_METIERS_2022_RESTAURATION.pdf', category_name: 'produits' },
            { name: 'Fiche Librairie', url: 'BIMEDIA_FICHE_METIERS_2022_LIBRAIRIE.pdf', category_name: 'produits' },
            { name: 'Fiche Presse', url: 'BIMEDIA_FICHE_METIERS_2022_PRESSE.pdf', category_name: 'produits' },
            { name: 'Fiche Tabac', url: 'BIMEDIA_FICHE_METIERS_2022_TABAC.pdf', category_name: 'produits' },
            { name: 'Fiche Fleuriste', url: 'BIMEDIA_FICHE_METIERS_2022_FLEURISTE.pdf', category_name: 'produits' },
            { name: 'Fiche Matériel', url: 'BIMEDIA_FICHE_METIERS_2022_MATERIEL.pdf', category_name: 'produits' },
            { name: 'Plaquette corporate', url: 'BIMEDIA_PLAQUETTE_CORPORATE_2022.pdf', category_name: 'produits' },
            { name: "Fiche Produit Vape", url: 'FLYER_A5_VAPE_2022.pdf', category_name: 'produits' },
            { name: "Fiche Produit Bar", url: 'FLYER_A5_BAR_2022.pdf', category_name: 'produits' },
            { name: 'Fiche Produit B Compact', url: 'FLYER_A4_B_Compact.pdf', category_name: 'produits' },
            { name: 'Fiche Produit B Moov', url: 'FLYER_A4_FICHE_TECHNIQUE_B_MOOV_2022.pdf', category_name: 'produits' },
            { name: 'Fiche Produit B Green', url: 'FLYER_A4_FICHE_TECHNIQUE_B_GREEN_2022.pdf', category_name: 'produits' },
            { name: 'Fiche Produit B Smart', url: 'FLYER_A4_FICHE_TECHNIQUE_B_SMART_2022.pdf', category_name: 'produits' },
            { name: 'Fiche Produit PC Dell Pro 14 Essential PV14250', url: 'pc.pdf', category_name: 'produits' },
            { name: 'Fiches Produit Imprimantes', url: 'Fiches_imprimantes.pdf', category_name: 'produits' },
            { name: "Fiche Produit Scan'Up", url: 'FLYER_A4_FICHE_TECHNIQUE_ALL_IN_ONE_2022.pdf', category_name: 'produits' },
            { name: 'Fiche Produit Tiroir C430', url: 'FP_Tiroir_C430.pdf', category_name: 'produits' },
            {
                name: 'Fiche Produit Tiroir Baby et Flip Top',
                url: 'FP_Tiroir_Baby_et_Flip_Top.pdf',
                category_name: 'produits'
            },
            { name: 'Fiche Produit Move 5000', url: 'fiche_move5000_fr_2020.pdf', category_name: 'produits' },
            { name: 'Fiche Produit Desk 5000', url: 'fiche_desk5000_fr_2020.pdf', category_name: 'produits' },
            { name: 'Fiche Produit V200', url: 'PlaquetteV200cP200_V2.pdf', category_name: 'produits' },
            { name: 'Fiche Produit V240', url: 'V240m.pdf', category_name: 'produits' },
            {
                name: 'Fiche Technique imprimante ticket',
                url: 'Fiche_technique_imprimante_ticket.pdf',
                category_name: 'produits'
            },
            { name: 'Fiche Produit scanners', url: 'PDF_Scanner.pdf', category_name: 'produits' },
            {
                name: 'Fiche Produit imprimante ticket Mobile MPB30',
                url: 'Leaflet_MP_B30_2019_1.pdf',
                category_name: 'produits'
            },
            { name: 'Guide terminal de paiement A920 Pro', url: 'Guide_terminal_de_paiement_A920_Pro.pdf', category_name: 'produits' },

            // services
            { name: 'Flyer Prolaser', url: 'Flyer_Prolaser_12032025.pdf', category_name: 'services' },
            { name: 'Plaquette services digitaux', url: 'Plaquette_services_digitaux_2025.pdf', category_name: 'services' },
            { name: 'Flyer B Booster', url: 'FLYER_A5_B_BOOSTER_2022.pdf', category_name: 'services' },
            { name: 'Fiche Produit Market pay', url: 'FLYER_A5_MARKET_PAY_2022.pdf', category_name: 'services' },
            { name: 'Fiche Produit MoneyGram', url: 'Fiche_produit_MoneyGram.pdf', category_name: 'services' },
            {
                name: 'Rémunérations des services TRAD',
                url: 'RÉMUNÉRATIONS_TABAC_PRESSE_TRAD_26-03-16.pdf',
                category_name: 'services'
            },
            {
                name: 'Rémunérations des services NAP',
                url: 'RÉMUNÉRATIONS_TABAC_PRESSE_NAP_26-03-16.pdf',
                category_name: 'services'
            },
            {
                name: 'Rémunérations des services BOULANGERIE',
                url: 'RÉMUNÉRATIONS_BOULANGERIE_22-12-01.pdf',
                category_name: 'services'
            },
            {
                name: 'Fichier de réintégration de données',
                url: 'Fichier_de_reintegration_de_donnees.xls',
                category_name: 'services'
            },
            { name: 'Contrat Leascorp', url: 'contrat_leascorp_bimedia.pdf', category_name: 'services' },
            { name: "Protocole d'agrément PVA", url: 'Protocole_agrement_PVA.pdf', category_name: 'services' },
            { name: 'Guide D\'utilisation B Booster', url : 'Guide_utilisation_B_Booster.pdf', category_name: 'services'},


            // contrat d'avenir
            { name: "Contrat d'Avenir", url: "Contrat d'Avenir 2017-2021.pdf", category_name: 'contrat_avenir' },
            { name: "Argumentaire contrat d'avenir", url: 'Argumentaire.pdf', category_name: 'contrat_avenir' },
            { name: 'Communiqué', url: "Communique-4eme-contrat-d'avenir.pdf", category_name: 'contrat_avenir' },

            // dillicom
            { name: 'Contrat FEL abonnemment', url: 'contrat_fel_abonnement.pdf', category_name: 'dilicom' },
            { name: 'Contrat FEL à la demande', url: 'contrat_fel_demande.pdf', category_name: 'dilicom' },
            {
                name: 'Questionnaire découverte librairie',
                url: 'dilicom_questionnaire_decouverte_librairie.pdf.pdf',
                category_name: 'dilicom'
            },
            { name: 'Récapitulatif offre NAP', url: 'dilicom_recap_nap.pdf', category_name: 'dilicom' },
            {
                name: 'Guide de remplissage CONTRAT FEL ABONNEMENT EXCLUSIF FINAL',
                url: 'Guide_de_remplissage_CONTRAT_FEL_ABONNEMENT_EXCLUSIF_FINAL.pdf',
                category_name: 'dilicom'
            },
            {
                name: 'Guide de remplissage CONTRAT FEL A LA DEMANDE',
                url: 'Guide_de_remplissage_CONTRAT_FEL_A_LA_DEMANDE.pdf',
                category_name: 'dilicom'
            },
            { name: 'Liste des éditeurs partenaires', url: 'dilicom_partenaires.pdf', category_name: 'dilicom' },

            // cgv
            { name: 'CGV Caisse', url: 'CGV_20230116.pdf', category_name: 'cgv' },
        ];

        self.CATEGORIES = [
            { name: 'produits', label: 'Informations Produits' },
            { name: 'services', label: 'Informations des Services' },
            { name: 'deloitte', label: 'Subvention Deloitte' },
            { name: 'contrat_avenir', label: "Contrat d'Avenir" },
            { name: 'dilicom', label: 'Abonnement Dilicom' },
            { name: 'cgv', label: 'CGV' }
        ];

        return self;
    }

    FilesService.$inject = ['files', '$rootScope'];

    angular.module('app.bdc.files.filesService', []).factory('filesService', FilesService);
});
